export class ChangeOrderAssignment {
  assignmentCodeId: number;
  engagementId: number;
  collaborationSiteId:string;
  assignmentCode: string;
  assignmentName: string;
  solutionCodeId:number;
  checked: boolean;
  visible: boolean;
  estimatedCompletetionDate: string;
  incrementalFees: string;
  grossMargin: string;
  StartDateCtrlId: string;
  estimatedComplationError:boolean;
  incrementalFeesError: boolean;
  grossMarginError: boolean;
  grossMarginErrorMessage: string;
  estimatedComplationRequiredError:boolean;
  incrementalFeesRequiredError: boolean;
  grossMarginRequiredError: boolean;
  estimatedStartDate: string;
  createdDate: string;
  createdBy: string;
  realization: number;
  assignmentAdministrator: string;
  adminEmailId: string;
  adminContactNo: string;
  cmsEPPMDName: string;
  cmsEPPMDEmailId: string;
  engagementTypeId: string;
  isContingent: boolean;
  isPrimaryAssignment: boolean;
  netFees:number;
  engagementStartDate: string;
  engagementEndDate: string;
  officeLocationCodeId: number;
  estimatedGrossMargin: number;
  clientBillingContactName: string;
  clientBillingContactTitleId: number;
  clientBillingContactEmail: string;
  collaborationSiteName: string;
  officeLocationCodeName: string;
  estimatedGrossMarginInCurrencyFormat: string;
  clientBillingContactTitle: string;
  clientCode: string;
  isGrossMarginRequire: boolean;
  isEngagementStartDateRequired?: boolean = false;
  isEngagementEndDateRequired?: boolean = false;
  eqcrName: string;
  eqcrEmailId: string;
  solutionCode: string;
  solutionCodeDescription: string;
  opportunityId?: string;
  opportunityName?: string;
  opportunityServiceId:string;
  dayShapeLink?: string;
  isChangeOrderAssignment: boolean = false;
  }